import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AiMessage } from '../models/ai-message.model';

export interface AssistantContext {
  courseId?: number;
  courseName?: string;
}

@Injectable({ providedIn: 'root' })
export class AssistantService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _messages = new BehaviorSubject<AiMessage[]>([]);
  private _context = new BehaviorSubject<AssistantContext>({});

  readonly isOpen$ = this._isOpen.asObservable();
  readonly messages$ = this._messages.asObservable();
  readonly context$ = this._context.asObservable();

  /** Emits courseId when AI modifies course data so route components can reload. */
  readonly courseModified$ = new Subject<number>();

  get isOpen(): boolean { return this._isOpen.value; }
  get messages(): AiMessage[] { return this._messages.value; }
  get context(): AssistantContext { return this._context.value; }

  open(): void { this._isOpen.next(true); }
  close(): void { this._isOpen.next(false); }
  toggle(): void { this._isOpen.next(!this._isOpen.value); }

  setContext(ctx: AssistantContext): void { this._context.next(ctx); }
  setMessages(msgs: AiMessage[]): void { this._messages.next(msgs); }

  notifyCourseModified(courseId: number): void { this.courseModified$.next(courseId); }
}
